import { Injectable } from "@angular/core";
import { DataModel, MetaModel, WidgetModel } from "common/models/utility-models/base-model";
import { FormWidgetService } from "../form-widget.service";
import { SystemService } from "common/services/core-services/system.service";
import { SmMetaModel } from "common/models/utility-models/meta-model";
import { TrainersStudentModel } from "common/models/page-models/Trainer Student/trainers-student-data.model";
import { TrainersStudentMetaModel } from "common/models/page-models/Trainer Student/trainers-student-form-meta.model";
import { TrainersStudentFormDataService } from "common/services/data-services/trainer-student/trainers-student-form.data.service";
import { CategoryListDataService } from "common/services/data-services/custom-service/categoryList-services";

@Injectable({
    providedIn: 'root'
})
export class TrainersStudentFormWidgetService extends FormWidgetService<TrainersStudentModel> {
    packageListService: any;
    stateListService: any;
    constructor(protected ds: TrainersStudentFormDataService, private ss: SystemService, private categoryList: CategoryListDataService ) {
        super(ds);
    }

    getMetaModel(): MetaModel {
        const meta = new TrainersStudentMetaModel();
        return meta.getMetaModel();
    }

    override prepareMetaModel(dataModel: TrainersStudentModel, metaModel: TrainersStudentMetaModel, routeData: WidgetModel): Promise<TrainersStudentMetaModel> {
        return new Promise<TrainersStudentMetaModel>((resolve, reject) => {
            this.categoryList.postData('').then((data) => {
                // console.log(data, metaModel);
                metaModel.properties['category_id'].options = data.details;
            })
            resolve(metaModel);
        });
    }
   
}
